var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092",
    transform: "translate(-0.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    transform: "translate(0.167)",
    fill: "none",
    stroke: "#102250",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-add",
    "data-name": "Icon ionic-md-add",
    d: "M14.75,11.283H11.283V14.75H10.217V11.283H6.75V10.217h3.467V6.75h1.067v3.467H14.75Z",
    transform: "translate(-2.75 -2.75)",
    fill: "#102250"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusico);
export default __webpack_public_path__ + "static/media/plusico.4fdd63c162f4e039d89bad45b7b67fca.svg";
export { ForwardRef as ReactComponent };